<template>
    <div class="float-left">
        <b-button
            variant="success"
            @click="abrirModal()">
            Adicionar
        </b-button>
        <documentos-form
            :idPrestacaoFinal="idPrestacaoFinal"
            :convenio="convenio"
            :dataServicos="dataServicos"
            @atualizarLista="$emit('atualizarLista')"
            operacaoProp="INSERIR"
            :mostrarModal="mostrarModal"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
            :erros="erros"
        ></documentos-form>
    </div>
</template>

<script>
import DocumentosForm from './DocumentosForm'

export default {
    components: {
        DocumentosForm,
    },

    props: {
        convenio: {
            type: Object,
            default: () => ({})
        },
        idPrestacaoFinal: {
            type: Number,
            default: 0
        },
        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            mostrarModal: false,
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },
        
        salvar(documentoConvenioDto) {
            this.$store.dispatch('addRequest')
                this.dataServicos.inserirDocumentosPrestacaoFinal(documentoConvenioDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$emit('atualizarLista')
                        }
                        else{
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },
    }
}
</script>

